import React, { useState } from "react";
import Axios from "axios";

import { baseUrl } from "../config";

const CODE_LENGTH = 5;

const Home = () => {
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState("");
  const [joinCode, setJoinCode] = useState("");

  const createLobby = (e) => {
    e.preventDefault();
    if (isCreating) return;
    setIsCreating(true);
    setError("");

    Axios.get(`${baseUrl}/api/createLobby`, { withCredentials: true })
      .then(function (res) {
        window.location.href = `/${res.data.code}`;
      })
      .catch(function (err) {
        setIsCreating(false);
        setError(
          err?.response?.status === 429
            ? "Slow down a moment - too many lobbies created."
            : "Couldn't create a lobby. Try again in a second."
        );
      });
  };

  // Someone reading a code out loud is the normal way into a game, so there
  // has to be somewhere to type it.
  const joinLobby = (e) => {
    e.preventDefault();
    const code = joinCode.trim().toUpperCase();
    if (code.length !== CODE_LENGTH) {
      setError(`A lobby code is ${CODE_LENGTH} characters.`);
      return;
    }
    window.location.href = `/${code}`;
  };

  return (
    <div className="lobby-container">
      <div className="lobby home">
        <div className="form-content">
          <h1 className="home-title">Outlaw</h1>
          <p className="home-blurb">
            Outlaw is a team-based word game. You'll have a word to describe --
            but don't say any of the 5 banned words.
            <br />
            <br />
            Click below to start a game.
          </p>
        </div>

        {error && (
          <p className="form-error" role="alert">
            {error}
          </p>
        )}

        <form onSubmit={createLobby} className="home-actions">
          <button id="create-game" onClick={createLobby} disabled={isCreating}>
            {isCreating ? "Creating..." : "Create Lobby"}
          </button>
        </form>

        <form onSubmit={joinLobby} className="home-join">
          <label className="label" htmlFor="join-code">
            Or join with a code
          </label>
          <div className="home-join-row">
            <input
              id="join-code"
              type="text"
              inputMode="text"
              autoCapitalize="characters"
              autoComplete="off"
              spellCheck="false"
              maxLength={CODE_LENGTH}
              placeholder="ABC12"
              value={joinCode}
              onChange={(e) => setJoinCode(e.target.value.toUpperCase())}
            />
            <button
              type="submit"
              id="join-game"
              disabled={joinCode.trim().length !== CODE_LENGTH}
            >
              Join
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Home;
